import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import {
  faCheckCircle,
  faExclamationCircle,
  faTimes,
} from "@fortawesome/pro-solid-svg-icons";
import WithdrawalRequestPersonalInformationFields from "../../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestPersonalInformation";
import WithdrawalRequestContactInformationFields from "../../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestContactInformtion";
import WithdrawalRequestEmploymentAgeDetail from "../../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestEmployeeAgeDetails";
import WithdrawalRequestEmployeeClassification from "../../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestEmployeeClassification";
import WithdrawalRequestOtherInformation from "../../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestOtherInformation";

const EmployeeSliderDetails = ({
  fields,
  filteredValues,
  setMoreInfoSlideOpen,
}) => {
  const [keyValue, setKeyValue] = useState(1);
  const [tabColors, setTabColors] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  });
  const setTabClass = (tabValue) => {
    return keyValue == tabValue
      ? "active"
      : false
      ? tabColors[tabValue]
        ? "error"
        : "green"
      : "";
  };
  const setTabIcon = (tabValue) => {
    return tabColors[tabValue] == true ? faExclamationCircle : faCheckCircle;
  };

  const tabChange = (key) => {
    setKeyValue(key);
  };
  const setTabColor = (tabValue) => {
    return keyValue == tabValue
      ? "#2f80ed"
      : false
      ? tabColors[tabValue]
        ? "red"
        : "green"
      : "#bdbdbd";
  };
  return (
    <div>
      <div className="disp-flex-row justify-content-space-between dark-grey-color fw-500 ft-16 Border-Bottom census-tabs-head">
        <p className="plan-sub-heading">Employee Information</p>
        <FontAwesomeIcon
          icon={faTimes}
          style={{ cursor: "pointer" }}
          onClick={() => setMoreInfoSlideOpen(false)}
        />
      </div>
      <Tabs
        style={{ border: "none", marginTop: "20px" }}
        activeKey={keyValue}
        transition={false}
        onSelect={tabChange}
        mountOnEnter
        unmountOnExit
      >
        <Tab
          eventKey={1}
          title={
            <div>
              <FontAwesomeIcon icon={setTabIcon(1)} color={setTabColor(1)} />
              &nbsp;
              <span class="tabName">
                Personal <span className="pl-20">Details</span>
              </span>
            </div>
          }
          tabClassName={setTabClass(1)}
        >
          <WithdrawalRequestPersonalInformationFields
            fields={fields}
            filteredValues={filteredValues}
          />
        </Tab>
        <Tab
          style={{ border: "none" }}
          eventKey={2}
          title={
            <div>
              <FontAwesomeIcon icon={setTabIcon(2)} color={setTabColor(2)} />
              &nbsp;
              <span class="tabName">
                Contact Information &{" "}
                <span className="pl-20">Bank Account Details</span>
              </span>
            </div>
          }
          tabClassName={setTabClass(2)}
          disabled={false}
        >
          <WithdrawalRequestContactInformationFields
            fields={fields}
            filteredValues={filteredValues}
          />
        </Tab>
        <Tab
          eventKey={3}
          title={
            <div>
              <FontAwesomeIcon icon={setTabIcon(3)} color={setTabColor(3)} />
              &nbsp;
              <span class="tabName">
                Employment <br />
                <span className="pl-20">& Age Details</span>
              </span>
            </div>
          }
          tabClassName={setTabClass(3)}
          disabled={false}
        >
          <WithdrawalRequestEmploymentAgeDetail
            fields={fields}
            filteredValues={filteredValues}
          />
        </Tab>
        <Tab
          eventKey={4}
          title={
            <div>
              <FontAwesomeIcon icon={setTabIcon(4)} color={setTabColor(4)} />
              &nbsp;
              <span class="tabName">
                Employee <span className="pl-20">Classification</span>
              </span>
            </div>
          }
          tabClassName={setTabClass(4)}
          disabled={false}
        >
          <WithdrawalRequestEmployeeClassification
            fields={fields}
            filteredValues={filteredValues}
          />
        </Tab>
        <Tab
          eventKey={5}
          title={
            <div>
              <FontAwesomeIcon icon={setTabIcon(5)} color={setTabColor(5)} />
              &nbsp;
              <span class="tabName">
                Other <span className="pl-20">Information</span>
              </span>
            </div>
          }
          tabClassName={setTabClass(5)}
          disabled={false}
        >
          <WithdrawalRequestOtherInformation
            fields={fields}
            filteredValues={filteredValues}
          />
        </Tab>
      </Tabs>
    </div>
  );
};

export default EmployeeSliderDetails;
